module.exports = __webpack_public_path__ + "static/media/icon_search_btn.b1a03883.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_search_btn.svg
// module id = 484
// module chunks = 0